import { invert } from "lodash";

import GlobalFontSizes from "../constants/globalFontSizes";

const availablePercentages = [50, 60, 70, 80, 90, 100, 110, 120, 130, 140, 150];

const getZoomToFontSize = globalFontSize => {
  switch (globalFontSize) {
    case GlobalFontSizes.Small:
      return { 50: 6, 60: 7, 70: 8, 80: 10, 90: 11, 100: 12, 110: 13, 120: 14, 130: 16, 140: 17, 150: 18 };
    case GlobalFontSizes.Medium:
      return { 50: 7, 60: 8, 70: 9, 80: 10, 90: 12, 100: 13, 110: 14, 120: 16, 130: 17, 140: 18, 150: 20 };
    case GlobalFontSizes.Large:
      return { 50: 7, 60: 9, 70: 11, 80: 12, 90: 13, 100: 15, 110: 16, 120: 18, 130: 19, 140: 21, 150: 23 };
    case GlobalFontSizes.XLarge:
      return { 50: 9, 60: 10, 70: 12, 80: 14, 90: 15, 100: 17, 110: 19, 120: 20, 130: 22, 140: 24, 150: 26 };
    case GlobalFontSizes.XXLarge:
      return { 50: 10, 60: 11, 70: 13, 80: 15, 90: 17, 100: 19, 110: 21, 120: 23, 130: 25, 140: 27, 150: 29 };
  }
};
const getFontSizeToZoom = globalFontSize => invert(getZoomToFontSize(globalFontSize));

export default {
  availablePercentages,
  getZoomToFontSize,
  getFontSizeToZoom
};
